module.exports = __webpack_public_path__ + "src/assets/img/page8/80c9a6fe77bcce04b67f9429c48d69e7.jpg";